import React, { useState, useContext } from "react"
import { red, green } from "@material-ui/core/colors"
import { makeStyles } from "@material-ui/core/styles"
import { exportTable, fetchTable } from "../api/apiCalls"
import SRFMenu from "../components/SRFMenu"
import Button from "@material-ui/core/Button"
import ArrowBackIcon from "@material-ui/icons/ArrowBack"
import SaveIcon from "@material-ui/icons/Save"
import StandardsTable from "../components/StandardsTable"
import { UserContext } from "../contexts/UserContext"
import Skeleton from "@material-ui/lab/Skeleton"
import { MessagingContext } from "../contexts/MessagingContext"

const useStyles = makeStyles(() => ({
  button: {
    marginBottom: "20px",
  },
  error: {
    color: red[500],
  },
  buttonProgress: {
    color: green[500],
    marginLeft: "10px",
  },
}))

const StandardsPage = () => {
  const { user } = useContext(UserContext)
  const classes = useStyles()

  const [loading, setLoading] = useState(false)
  const [error, setError] = useState(null)
  const [data, setData] = useState(null)
  const [value, setValue] = useState(null)
  const [editable, setEditable] = useState(false)
  const [viewSelected, setViewSelected] = useState(false)
  const [title, setTitle] = useState("")
  const { addErrorMessage, addSuccessMessage } = useContext(MessagingContext)

  const saveSelected = (tablename) => {
    exportTable(user, tablename)
      .then((data) => {
        if (data.statusCode === 200) {
          addSuccessMessage(tablename, `saved and pushed as ${data.newFile}`)
        } else {
          addErrorMessage(tablename, "cannot be loaded to s3.")
        }
      })
      .catch((err) => console.log(err))
  }

  const onSelect = ({ value, label, editable }) => {
    setTitle(label)
    setLoading(true)
    setError(false)
    setValue(value)
    setEditable(editable)
    fetchTable(user, value)
      .then(async (response) => {
        if (response.ok) {
          let responseJSON = await response.json()
          setData(responseJSON)
          setViewSelected(true)
          setLoading(false)
        } else {
          throw new Error(`${value} table unable to load.`)
        }
      })
      .catch((error) => {
        setLoading(false)
        setError(error.message)
      })
  }

  console.log(" VALU E ", value)

  return (
    <div>
      {!viewSelected && !loading && !error ? (
        <SRFMenu onSelect={onSelect} />
      ) : (
        <>
          <div>
            <Button
              color="primary"
              variant="contained"
              onClick={() => {
                setViewSelected(false)
                setError("")
              }}
              className={classes.button}
              startIcon={<ArrowBackIcon />}
              disableElevation
            >
              Back To Menu
            </Button>
            {value !== "readersforcopy" && (
              <Button
                color="primary"
                variant="contained"
                onClick={() => {
                  saveSelected(value)
                  setError("")
                }}
                className={classes.button}
                startIcon={<SaveIcon />}
                disableElevation
                style={{ float: "right", backgroundColor: "green" }}
              >
                Save and Push
              </Button>
            )}
          </div>
          <br />
          {loading && (
            <div>
              <Skeleton variant="rect" animation="wave" height={800} />
            </div>
          )}
          {error && <p className={classes.error}>{error}</p>}
          {data && !loading && !error && (
            <StandardsTable
              title={title}
              value={value}
              editable={editable}
              data={data.data}
              columns={data.columns}
              loading={loading}
              error={error}
            />
          )}
        </>
      )}
    </div>
  )
}

export default StandardsPage
